import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Product from "./Shared/Product";

const badges = [
  { icon: "✦", text: "Dermatologist Approved" },
  { icon: "🌱", text: "Centella Extract 95%" },
  { icon: "🧪", text: "Barrier Strengthening" },
  { icon: "💧", text: "Hydrates & Repairs" },
];

const trustItems = [
  "Cruelty-Free",
  "Vegan Formula",
  "Fragrance-Free",
  "Sensitive-Skin Safe",
];

const HomeCicaCare = () => {
  const [cicaProducts, setCicaProducts] = useState([]);

  useEffect(() => {
    fetch(
      "https://ebay-backend.vercel.app/getProductsByCategories?name=Cica Care"
    )
      .then((res) => res.json())
      .then((data) => setCicaProducts(data));
  }, []);

  const products = cicaProducts?.slice(0, 4);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Cica Care Collection",
    itemListElement: products?.map((product, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: product?.name,
      url: `https://earthbeautyandyou.com/product/${product?.slug}`,
    })),
  };

  return (
    <section
      className="py-16 md:py-20 bg-gradient-to-b from-[#f0faf2] to-white overflow-hidden"
      aria-label="Cica Care Collection"
    >
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Hero */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 mb-16">
          {/* Left: Text */}
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-green-700 bg-green-100 px-3 py-1 rounded-full mb-4">
              Cica Care · Skin Barrier Healing
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
              Calm, Repair &amp; Restore
              <br />
              <span className="text-green-700">Your Sensitive Skin</span>
            </h2>
            <p className="text-gray-500 text-base mb-8 max-w-md mx-auto lg:mx-0">
              Powered by Centella Asiatica, our Cica range soothes irritation,
              repairs damaged skin barriers, and deeply hydrates for lasting comfort.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8 max-w-sm mx-auto lg:mx-0">
              {badges.map((b) => (
                <div
                  key={b.text}
                  className="flex items-center gap-2 bg-white border border-green-100 rounded-lg px-3 py-2 text-sm text-gray-700 shadow-sm"
                >
                  <span>{b.icon}</span>
                  <span>{b.text}</span>
                </div>
              ))}
            </div>

            <Link
              to="/product-category/cica care"
              className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white font-semibold px-7 py-3 rounded-full transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 text-sm tracking-wide"
            >
              Explore Full Cica Collection
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>

          {/* Right: Image */}
          <div className="flex-1 w-full max-w-lg rounded-2xl overflow-hidden shadow-xl relative">
            <img
              src="https://luvit.com.bd/wp-content/uploads/2025/11/Cica-Care-Mineral-Clay-Cleanser_front.png"
              alt="Cica Care Mineral Clay Cleanser"
              className="w-full h-72 md:h-[420px] object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-green-900/80 to-transparent p-5 backdrop-blur-sm">
              <p className="text-white font-semibold text-sm">
                Cica — The Miracle Herb for Skin Recovery 💚
              </p>
              <p className="text-green-100 text-xs mt-1 opacity-90">
                Used for centuries in Asian medicine to heal &amp; soothe.
              </p>
            </div>
          </div>
        </div>

        {/* Products */}
        <div className="mb-10 ">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center mt-36">
            Best-Selling Cica Care Essentials
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
            {products?.length > 0
              ? products.map((product) => (
                  <Product key={product?._id} product={product} />
                ))
              : Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className="rounded-xl bg-gray-100 animate-pulse h-72"
                  />
                ))}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-3">
          {trustItems.map((item) => (
            <div
              key={item}
              className="flex items-center gap-1.5 px-4 py-2 bg-white border border-green-100 rounded-full text-sm text-gray-700 font-medium shadow-sm"
            >
              <span className="text-green-600">✓</span> {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCicaCare;




// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Product from "./Shared/Product";

// const HomeCicaCare = () => {
//   const [cicaProducts, setCicaProducts] = useState([]);

//   useEffect(() => {
//     fetch("https://ebay-backend.vercel.app/getProductsByCategories?name=Cica Care")
//       .then(res => res.json())
//       .then(data => setCicaProducts(data));
//   }, []);

//   const products = cicaProducts?.slice(0, 4);

//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "ItemList",
//     name: "Cica Care Collection",
//     itemListElement: products?.map((product, index) => ({
//       "@type": "ListItem",
//       position: index + 1,
//       name: product?.name,
//       url: `https://earthbeautyandyou.com/product/${product?.slug}`
//     })),
//   };

//   return (
//     <section className="bg-[#F9FFFA] py-16 w-full relative container mx-auto">

//       {/* SEO Structured Data */}
//       <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

//       {/* 🌿 Hero Section */}
//       <div className="flex flex-col md:flex-row items-center md:items-start mx-auto w-[90%] 2xl:w-[65%] gap-10">
       
//         {/* Left Content */}
//         <div className="flex-1 text-center md:text-left">
//           <p className="uppercase text-green-700 font-semibold tracking-wide text-sm">
//             Cica Care • Skin Barrier Healing
//           </p>

//           <h2 className="mt-2 text-3xl md:text-4xl font-extrabold text-green-800 leading-tight">
//             Calm, Repair & Restore<br/> Your Sensitive Skin
//           </h2>

//           <p className="mt-4 text-gray-600 text-base">
//             Powered by **Centella Asiatica**, our Cica range is formulated to
//             soothe irritation, repair damaged skin barriers, and deeply hydrate.
//           </p>

//           <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-700">
//             <div className="flex items-center gap-2">
//               ✅ Dermatologist Approved
//             </div>
//             <div className="flex items-center gap-2">
//               🌱 Centella Extract 95%
//             </div>
//             <div className="flex items-center gap-2">
//               🧪 Skin Barrier Strengthening
//             </div>
//             <div className="flex items-center gap-2">
//               💧 Hydrates & Repairs
//             </div>
//           </div>

//           <Link
//             to="/product-category/cica care"
//             className="inline-block mt-8 bg-green-700 text-white px-8 py-3 rounded-lg shadow hover:bg-green-800 transition font-semibold text-sm tracking-wide"
//           >
//             Explore Full Cica Collection →
//           </Link>
//         </div>

//         {/* Right Image Area */}
//         <div className="flex-1 relative w-full h-[300px] md:h-[420px] rounded-xl overflow-hidden shadow-lg">
//           <img
//             src="https://luvit.com.bd/wp-content/uploads/2025/11/Cica-Care-Mineral-Clay-Cleanser_front.png"
//             alt="Cica Care"
//             className="w-full h-full object-cover"
//           />

//           <div className="absolute bottom-0 left-0 right-0 bg-green-900 bg-opacity-60 text-white p-4 backdrop-blur-md">
//             <p className="font-semibold">
//               Cica — The Miracle Herb for Skin Recovery 💚
//             </p>
//             <p className="text-xs opacity-90">
//               Used for centuries in Asian medicine to heal wounds & soothe inflammation.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Product Display */}
//       <div className="mt-14  ">
//         <h3 className="text-xl font-bold text-green-800 mb-4 text-center md:text-left">
//           Best-Selling Cica Care Essentials
//         </h3>

//         <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
//           {products?.map((product) => (
//             <Product key={product?._id} product={product} />
//           ))}
//         </div>
//       </div>

//       {/* Trust Badges */}
//       <div className="mt-12 flex flex-wrap justify-center gap-6 text-gray-700 text-xs sm:text-sm font-medium">
//         <div className="px-3 py-2 bg-white rounded-md shadow">✔️ Cruelty-Free</div>
//         <div className="px-3 py-2 bg-white rounded-md shadow">✔️ Vegan Formula</div>
//         <div className="px-3 py-2 bg-white rounded-md shadow">✔️ Fragrance-Free</div>
//         <div className="px-3 py-2 bg-white rounded-md shadow">✔️ Sensitive-Skin Safe</div>
//       </div>

//     </section>
//   );
// };

// export default HomeCicaCare;

